if (!ROTATING_SECTION) {
  var ROTATING_SECTION = true;
  (function () {
    const sections = Array.from(document.querySelectorAll('.rotating-features'));
    for (const section of sections) {
      const txts = Array.from(section.querySelectorAll('.rotating-features__feature-text'));
      const imgs = Array.from(section.querySelectorAll('.rotating-features__feature-img'));
      if (txts.length == 0 || txts.length != imgs.length) continue;
      const fadeIn = parseFloat(section.dataset.fadeIn);
      const fadeOut = parseFloat(section.dataset.fadeOut);
      const linger = parseFloat(section.dataset.linger) + fadeIn + fadeOut;
      var idx = -1;
      function next(next = undefined) {
        if (idx >= 0) {
          txts[idx].setAttribute('style', `animation: ${fadeOut}s 1 forwards ease-out rotating-features-fade;`);
          imgs[idx].setAttribute('style', `animation: ${fadeOut}s 1 forwards ease-out rotating-features-fade;`);
        }
        idx = next ?? (idx + 1) % txts.length;
        const thisIdx = idx;
        setTimeout(
          () => txts[thisIdx].setAttribute('style', `animation: ${fadeIn}s 1 forwards ease-in-out rotating-features-pop;`),
          fadeOut * 1000,
        );
        setTimeout(
          () => imgs[thisIdx].setAttribute('style', `animation: ${fadeIn}s 1 forwards ease-in-out rotating-features-pop;`),
          fadeOut * 2000,
        );
      }
      next();
      var auto = setInterval(next, linger * 1000);
      document.addEventListener('shopify:block:select', function (event) {
        const childIdx = txts.indexOf(event.target);
        if (childIdx >= 0) {
          if (auto) {
            clearInterval(auto);
            auto = undefined;
          }
          next(childIdx);
        }
      });
    }
  })();
}
